import { render, staticRenderFns } from "./Agroindustrias.vue?vue&type=template&id=3c23a6a1"
import script from "./Agroindustrias.vue?vue&type=script&lang=js"
export * from "./Agroindustrias.vue?vue&type=script&lang=js"
import style0 from "./Agroindustrias.vue?vue&type=style&index=0&id=3c23a6a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports